import React from 'react';

export default function WalletIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-wallet"><path className="primary" d="M2 5c0 1.1.9 2 2 2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5zm16 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path className="secondary" d="M4 3h11a2 2 0 0 1 2 2v2H4a2 2 0 1 1 0-4z"/></svg>
    </Tag>
  )
};
